import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import linkedin from '../../assets/images/linkedin.svg';
import instagram from '../../assets/images/instagram-i.svg';
import x from '../../assets/images/x.svg';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentYear = new Date().getFullYear();
  const isRTL = i18n.language === 'ar';

  return (
    <footer className="footer" id="footer">
      <div className="container">
        <div className={`footer-content ${!isRTL ? 'ltr-text' : ''}`}>
          <div className="footer-logo">
            <h2 className='footer-title'>{t('footer.contact')}</h2>
            <p>{t('footer.description')}</p>
            <ul className='footer-contact-links'>
              <li>
                <a href='https://www.linkedin.com/' target='_blank' rel='noopener noreferrer'>
                  <img src={linkedin} alt={t('footer.linkedin')} />
                </a>
              </li>
              <li>
                <a href='https://www.instagram.com/' target='_blank' rel='noopener noreferrer'>
                  <img src={instagram} alt={t('footer.instagram')} />
                </a>
              </li>
              <li>
                <a href='https://x.com/' target='_blank' rel='noopener noreferrer'>
                  <img src={x} alt={t('footer.twitter')} />
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-links">
            <div className="footer-links-section">
              <p>
                {t('footer.email')}: <a href="mailto:info@baleeg-om.com">info@baleeg-om.com</a>
                <br />
                {t('footer.phone')}: <a href="tel:+96896758894">+968-96758894</a>
                <br />
                {t('footer.address')}: {t('footer.address_value')}
                <br />
                {t('footer.hours')}: {t('footer.hours_value')}
              </p>
            </div>
          </div>
        </div>

        <div className={`footer-bottom ${!isRTL ? 'ltr-text' : ''}`}>
          <p>
            &copy; {currentYear} {t('footer.brand')}. {t('footer.rights')}
          </p>
          <div className="footer-bottom-links">
            <Link to="/PrivacyPolicy">{t('footer.privacy')}</Link>
            <Link to="/TermsCondithions">{t('footer.terms')}</Link>
            <Link to="/RefundPolicy">{t('footer.refund')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;